import axios from 'axios';

export const addFavorite = ({commit, state}, item_id) => {
  return new Promise(() => {
    commit('addFavorites', item_id);
    localStorage.setItem('favorites', JSON.stringify(state.favorites));
    commit('addMessage', 'お気に入り登録をしました');
    axios.post('http://admin.harigu.com/api/favorites/' + item_id, {
      userId: localStorage.getItem('userId')
    })
  });
};
export const removeFavorite = ({commit, state}, item_id) => {
  return new Promise(() => {
    commit('removeFavorite', item_id);
    localStorage.setItem('favorites', JSON.stringify(state.favorites));
    commit('addMessage', 'お気に入り登録を解除しました');
    // axios.post('http://admin.harigu.com/api/favorites/' + item_id)
    //   .then(response => {
    //     console.log(response);
    //   })
  });
};
// export const addCart = ({commit, state}, cart) => {
//   return new Promise((resolve, reject) => {
//     axios.post('http://admin.harigu.com/api/cart', cart)
//       .then(response => {
//         cart.id = response.data.id;
//         commit('addCart', cart);
//       });
//   });
// };

export const setPriceCalculation = async ({commit}) => {
  const response = await axios.get('http://admin.harigu.com/api/price');
  commit('setPriceCalculation', response.data);
};
